module.exports = __webpack_public_path__ + "static/media/orbit2.967014a4.svg";